import type { ReactNode } from 'react';
import { useNavigation } from 'react-router';
import { useSpinDelay } from 'spin-delay';
import { CircularProgress } from '~/common/components/CircularProgress';
import { cn } from '~/common/utils/styleUtil';

export function FilterCatalogNavigationItem({
  filterQueryParam,
  children,
  onClick,
  className
}: Readonly<{
  className?: string;
  filterQueryParam: string;
  children: ReactNode;
  onClick: () => void;
}>) {
  const navigtion = useNavigation();
  const isNavigatingFilter =
    navigtion.state === 'loading' && navigtion.location?.search === `?${filterQueryParam}=true`;
  const showProgress = useSpinDelay(isNavigatingFilter, { delay: 0, minDuration: 600 });

  return (
    <button type="button"
      className={cn(
        'cursor-pointer p-3 pl-0 w-full text-left hover:text-primary flex gap-2 items-center border-b justify-between',
        className
      )}
      onClick={onClick}
    >
      <div className={'flex gap-2'}>{children}</div>
      {showProgress && <CircularProgress size={'sm'} />}
    </button>
  );
}
